<template>
  <el-dialog :visible="showModal" width="70%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ propsData.name }}
        <div  v-if="cameraDetail.length > 0" @click="openVideo"  class="header-video-btn">
          <i class="el-icon-video-camera"></i>
          查看监控
        </div>
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>

    <div class="charge-data-detail">
      <div class="detail-wrap">
        <div class="detail-left">
            <div class="detail-icon">
              <img src="../../assets/image/icon_normal.png" alt="">
            </div>
            <div class="detail-status green">{{ propsData.zt }}</div>
        </div>
        <div class="detail-main">
          <div class="detail-row">
            <div class="row-title">站点编号</div>
            <div class="row-content">{{ propsData.id }}</div>
          </div>
          <div class="detail-row">
            <div class="row-title">站点地址</div>
            <div class="row-content">{{ propsData.address }}</div>
          </div>

        </div>
      </div>

      <div class="detail-title">逆变器信息</div>
      <div class="detail-table">
        <div class="table-main">
          <el-table
              :data="equipmentList.slice((currentPage - 1)*pageSize,currentPage*pageSize)"
              border
              style="width: 100%">

            <el-table-column
                prop="equipmentName"
                label="逆变器名称"
                width="300px"
                sortable
            />

            <el-table-column
                prop="equipmentSn"
                label="逆变器sn"
                width="450px"
                sortable
            />

            <el-table-column
                prop="kwp"
                label="逆变器装机容量"
                width="300px"
                sortable
            />

            <el-table-column
                prop="ratedPower"
                label="额定功率"
                width="300px"
                sortable/>

            <el-table-column
                prop="nowKw"
                label="实时功率"
                width="300px"
                sortable
            />

            <el-table-column
                prop="status"
                label="设备状态"
                width="300px"
                sortable>
              <template slot-scope="scope">
                <span>{{ getStatusName(scope.row.status)}}</span>
              </template>
            </el-table-column>

            <el-table-column
                prop="todayKwh"
                label="日发电量"
                width="300px"
                sortable/>

            <el-table-column
                prop="monKwh"
                label="月发电量"
                width="300px"
                sortable/>

            <el-table-column
                prop="yearKwh"
                label="年发电量"
                width="300px"
                sortable/>
          </el-table>

          <el-pagination
              @current-change="changePage"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="equipmentList.length">
          </el-pagination>
        </div>
      </div>
    </div>

    <TpLinkVideoList ref="TpLinkVideoList"/>
<!--    <div style="width: 900px; height: 520px">
      <TpLinkVideo
          ref="player"
          :app-key="appKey"
          :app-secret="appSecret"
          :url="relayUrl"
          streamType="video"
          :autoplay="true"
          :muted="true"
          :volume="1"
          :useWebGL="true"
          @ready="onReady"
          @error="onError"
      />
      <button @click="$refs.player.play()">播放</button>
      <button @click="$refs.player.pause()">暂停</button>
      <button @click="$refs.player.snapshot('snap.png')">截图</button>
      <button @click="$refs.player.enterFullscreen()">全屏</button>
    </div>-->


  </el-dialog>
</template>

<script>
import {Loading} from "element-ui";

import TpLinkVideoList from "@/components/TpLinkVideo/TpLinkVideoList.vue";
export default {
  name: "PhotovoltaicDetail",
  components: {  TpLinkVideoList },
  data() {
    return {
      appKey:"c2db8287cc51472e887b4b8e7673de0f",
      appSecret:"678eca05925c466c905a2f97ff0e7122",
      showModal: false,
      propsData: {},
      detailData: {},
      cameraDetail:[],
      equipmentList:[],
      relayUrl: '',
      dataList: [],
      pageSize: 10,
      currentPage: 1
    };
  },
  methods: {
    open(data) {
      this.propsData = data;
      const loading = Loading.service({
        lock: true,
        text: "正在加载电站信息..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      Promise.allSettled([  this.getPhotovoltaicEquipList(),this.getStationCameraList()]).then(() => {
        loading.close();
        this.showModal = true;
      });
    },
    changePage(page) {
      this.currentPage = page;
    },
    openVideo(){
        if(!this.cameraDetail ||this.cameraDetail.length < 1){
           this.$message('暂无可看监控');
           return false;
        }
        this.$refs.TpLinkVideoList.open({
          name: this.propsData.name,
          videoList: this.cameraDetail
        });
    },
    getPhotovoltaicEquipList() {
      return new Promise(resolve => {
        this.$api.loadPhotovoltaicEquipList({stationId: this.propsData.id,customerType : this.propsData.customizedType})
            .then(res => {
              this.equipmentList = res.data;
              resolve();
            });
      });
    },
    getStatusName(status){
      switch (status) {
        case "0":
          return "离网";
        case "1":
          return "在线";
        case "2":
          return "停机";
        case "3":
          return "停机告警";
        case "4":
          return "故障";
        case "6":
          return "离线";
        default:
          return "--";
      }
    },
    getStationCameraList(){
      return new Promise(resolve => {
        this.$api.getDeviceMonitoring({name: this.propsData.name}).then(res => {
          if(res.data){
             this.cameraDetail = res.data;
          }
          resolve();
        }).catch(e=>{
          console.log(e);
          resolve();
        });
      });
    },
    onReady () { console.log('ready') },
    onError (e) { console.error(e) }
  }
};
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";

::v-deep.el-table .el-table__header-wrapper tr th {
  background-color: #0CC874;
}

::v-deep.el-table td, ::v-deep.el-table th {
  height: 90px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
}

::v-deep .el-table__body{
  pointer-events: none !important;
}
::v-deep.el-table .cell {
  line-height: 40px;
}

::v-deep.el-table .caret-wrapper{
  transform: scale(2);
  margin-left: 10px;
}
.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn{
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-left: 60px;
    width: 220px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border:  solid 2px #fff;
    border-radius: 60px;
    cursor: pointer;
    i{
      font-size: 40px;
      margin-right: 10px;
    }
    &:hover{
      opacity: .8;
    }
  }


  .header-close{
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;
    i{
      font-size: 40px;
    }
    cursor: pointer;
    &:hover{
      opacity: .8;
    }
  }
}

.detail-title{
  font-size: 32px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 15px;
}

.charge-data-list {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 40px;
}

.charge-data-item {
  float: left;
  width: 32%;
  height: 560px;
  margin-right: 2%;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 30px;
  border: solid 2px #ccc;
  border-radius: 10px;

  &:nth-of-type(3n) {
    margin-right: 0;
  }

  .item-title {
    font-size: 30px;
    color: #328CE6;
    padding-bottom: 20px;
    line-height: 40px;
  }

  .item-main {
    position: relative;
    height: calc(100% - 60px);
  }

  .item-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 120px;
    height: 64px;
    line-height: 60px;
    color: #2E78C4;
    text-align: center;
    border: solid 4px #2E78C4;
    font-size: 28px;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    //background: #fff;
    &:hover {
      opacity: .8;
    }
  }

  .item-icon {
    display: block;
    float: left;
    width: 200px;
    margin-top: 40px;

    img {
      width: 100%;
    }
  }

  .item-content {
    float: right;
    width: calc(100% - 240px);
  }

  .item-row {
    @extend .clearfix;
    padding: 4px 0;

    .row-title {
      float: left;
      width: 260px;
      line-height: 40px;
      font-size: 28px;
      color: #CFCFD1;
      box-sizing: border-box;
      padding-right: 20px;
      text-align: right;
    }

    .row-content {
      float: left;
      width: calc(100% - 260px);
      line-height: 36px;
      font-size: 28px;
      color: #CFCFD1;
    }
  }
}


.charge-data-detail {
  height: 1600px;
  box-sizing: border-box;
  padding: 40px;

  .detail-wrap {
    height: 384px;
    border-top: solid 2px #ccc;
  }

  .detail-left {
    float: left;
    width: 500px;
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    border-left: solid 2px #ccc;
    border-right: solid 2px #ccc;
    border-bottom: solid 2px #ccc;

    .detail-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #D1D2D3;
      margin-bottom: 40px;
    }

    .detail-icon {
      margin: 0 auto;
      width: 260px;
      height: 260px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .detail-status {
      font-size: 30px;
      margin-top: 32px;
      text-align: center;

      &.green {
        color: #63CA2D;
      }

      &.red {
        color: #E6474A;
      }

      &.gray {
        color: #8E8E8E;
      }

      &.purple {
        color: #6B51FF;
      }
    }
  }

  .detail-main {
    float: left;
    width: calc(100% - 500px);
    height: 100%;
    box-sizing: border-box;

    .detail-row {
      float: left;
      width: 40%;
      height: 96px;

      &.width100 {
        width: 100%;

        .row-title, .row-content {
          width: 50%;
        }
      }

      &:nth-of-type(2n) {
        width: 60%;
      }

      box-sizing: border-box;

      .row-title {
        float: left;
        width: 360px;
        height: 96px;
        line-height: 96px;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        box-sizing: border-box;
        background: rgba(255, 255, 255, .1);
        padding: 0 30px;
        color: #CDCECF;
        font-size: 28px;
      }

      .row-content {
        float: left;
        width: calc(100% - 360px);
        height: 96px;
        line-height: 96px;
        padding: 0 30px;
        box-sizing: border-box;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        color: #BEBEC2;
        font-size: 28px;
        @extend .omit;
      }
    }
  }
}

.detail-table {
  position: relative;
  height: calc(100% - 522px);
  margin-top: 20px;

  .table-filter {
    height: 96px;
    margin-top: 30px;

    .filter-item {
      float: left;
      @extend .clearfix;
      width: 250px;
      transform: scale(2);
      margin-left: 130px;

      .filter-title {
        float: left;
        width: 80px;
        line-height: 38px;
        color: #BEBEC1;
      }

      .filter-content {
        float: left;
        width: calc(100% - 80px);
      }
    }
  }

  .table-main {
    height: calc(100% - 116px);

    * {
      font-size: 28px !important;
    }

    .el-table tbody tr {
      pointer-events: none;
    }

    .el-table thead {
      color: #fff;

      th.el-table__cell {
        background: transparent;
      }
    }

    .el-table .el-table__cell {
      padding: 25px;
    }

    .el-table .caret-wrapper {
      width: 34px;
      height: 54px;
    }

    .el-table .sort-caret {
      border-width: 10px;

      &.ascending {
        top: 0;
      }

      &.descending {
        bottom: 2px;
      }
    }
  }
}

::v-deep.el-pagination {
  margin-top: 50px;
}

::v-deep.el-pagination * {
  font-size: 28px !important;
}
</style>
